import { Card, Form, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useParams } from "react-router";
import { useEffect } from "react";
import CardFooterAction from "../../../components/CardFooterAction";
import { useGetDetailApi, useStoreUpdateApi } from "../../../hooks/useApi";
import CustomTextInput from "../../../components/CustomTextInput";
import { programStudyService } from "../../../services/program-study.service";

export default function ProgramStudyForm() {
  const { id } = useParams();
  const [form] = useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { data } = useGetDetailApi({
    id,
    serviceFn: programStudyService.findById,
    queryKey: ["program-study"],
  });

  const { storeMutation, updateMutation } = useStoreUpdateApi({
    service: programStudyService,
    form: form,
    messageApi: messageApi,
    queryKey: "program-study",
    route: "/master-data/program-study",
  });

  useEffect(() => {
    if (id && data) {
      form.setFieldsValue(data);
    }
  }, [form, id, data]);

  const isPending = storeMutation.isLoading || updateMutation.isLoading;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, data: values });
    }
  };

  return (
    <>
      {contextHolder}
      <Card
        title={(id ? "Ubah" : "Tambah") + " Program Studi"}
        actions={[
          <CardFooterAction
            key={"submit"}
            route={"/master-data/program-study"}
            onClick={form.submit}
            loading={isPending}
            primaryText="Simpan"
            secondaryText="Batal"
          />,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <CustomTextInput
            label="Nama Program Studi"
            name="name"
            rules={[
              { required: true, message: "Nama Program Studi harus diisi" },
            ]}
            disabled={isPending}
          />
        </Form>
      </Card>
    </>
  );
}
